"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayFieldType = displayFieldType;
exports.findIndexForPeriscope = findIndexForPeriscope;
exports.getPeriscopeSummaryRouteUri = getPeriscopeSummaryRouteUri;
exports.getPeriscopeMetadataRouteUri = getPeriscopeMetadataRouteUri;
const lib_1 = require("../types/lib.js");
const __1 = require("../index.js");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
function displayFieldType(typeString) {
    var _a;
    if (!(typeString === null || typeString === void 0 ? void 0 : typeString.startsWith('Lookup('))) {
        return typeString;
    }
    const commaSplit = typeString === null || typeString === void 0 ? void 0 : typeString.split(',');
    const lookupCount = (_a = commaSplit === null || commaSplit === void 0 ? void 0 : commaSplit.length) !== null && _a !== void 0 ? _a : 0;
    return lookupCount < 3 ? typeString : `${commaSplit === null || commaSplit === void 0 ? void 0 : commaSplit.slice(0, 2).join(',')}, +${lookupCount - 2})`;
}
function findIndexForPeriscope(cards, newPeriscopeId, openedFromIndex) {
    if (cards.length === 0) {
        return 0;
    }
    const index = openedFromIndex ? openedFromIndex : 0;
    const [rootPeriscope] = cards;
    const nextPeriscope = cards[index + 1];
    const currentPeriscope = cards[index];
    const sameAsRoot = newPeriscopeId === rootPeriscope.id;
    const sameAsNext = newPeriscopeId === (nextPeriscope === null || nextPeriscope === void 0 ? void 0 : nextPeriscope.id);
    const sameAsCurrent = newPeriscopeId === (currentPeriscope === null || currentPeriscope === void 0 ? void 0 : currentPeriscope.id);
    const sameAsAnyParent = cards.slice(0, index).some(
    /*	FUTURE: Remove comparison to `name` once all field endpoints are updated to
        provide the parentSonarObjectId. Matching on name (against a potential parentInternalName)
        is fuzzy and prone to edgecases. */
    (card) => card.id === newPeriscopeId || card.name === newPeriscopeId);
    if (!sameAsRoot && index < 0) {
        return 0;
    }
    if (sameAsRoot || sameAsNext || sameAsAnyParent || sameAsCurrent) {
        return null;
    }
    return index + 1;
}
function getPeriscopeSummaryRouteUri(type, id) {
    var _a;
    if (!type || !id) {
        return undefined;
    }
    const apiVersion = (0, lib_1.getSonarObjectTypeApiVersion)(type);
    if (type === sonar_ts_types_1.SonarObjectType.SonarTag) {
        return undefined;
    }
    const sourcePart = (_a = (0, __1.getSonarObjectTypeSourceLabel)(type)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const routePart = (0, __1.getSonarObjectTypePeriscopeRoutePart)(type);
    if (!apiVersion || !sourcePart || !routePart) {
        return undefined;
    }
    return `${apiVersion}/${sourcePart}/${routePart}/${id}/summary`;
}
function getPeriscopeMetadataRouteUri(type, id) {
    var _a;
    if (!type || !id || type === sonar_ts_types_1.SonarObjectType.SonarTag) {
        return undefined;
    }
    const apiVersion = (0, lib_1.getSonarObjectTypeApiVersion)(type);
    const sourcePart = (_a = (0, __1.getSonarObjectTypeSourceLabel)(type)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const routePart = (0, __1.getSonarObjectTypePeriscopeRoutePart)(type);
    if (!apiVersion || !sourcePart || !routePart) {
        return undefined;
    }
    return `${apiVersion}/${sourcePart}/${routePart}/${id}/metadata`;
}
//# sourceMappingURL=lib.js.map